import { storeModels } from './storeModels'
import { orderModels } from './orderModels'
import promoDataModel from './promoDataModel'
import pushNotificationDataModel from './pushNotificationDataModel'
import { productsDataModel } from './productsDataModel'

export const dataModels = {
    ...storeModels,
    ...orderModels,
    ...promoDataModel,
    ...pushNotificationDataModel,
    ...productsDataModel,
}
